import "~/js/modules/stickyNav";
import "~/js/modules/resort-home/slider-main";
import "~/js/modules/resort-home/inclusions";
import "~/js/modules/resort-home/rooms-and-suites-slider";
import "~/js/sections/root/includes/slider-countdown";
import "~/js/modules/countdown";

import ReviewPanel from "~/js/components/global/reviews/ReviewPanel";

import QuickQuote from "~/js/components/global/QuickQuote";

import dataLayerProvider from "~/js/modules/resorts/datalayer-provider";

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);
const guestReviews = document.getElementById("guest-reviews__target");
const quickQuoteNode = document.getElementsByClassName("resort-qq");
const { rstCode = "" } = window.beaches_app.page;

const readMore = document.getElementById("read-more-trigger");
const descText = document.querySelector(".intro-section .intro-content");

//autoplay
const $autoplay = window.location.search.includes("autoplay");
const $videoToggle = $(".js-magnific-video");

if ($autoplay) {
  $videoToggle[0].click();
}

// const message = document.querySelector('#find-travel-dates');
// const closeMessage = document.querySelector('#find-travel-dates .close-btn');

// closeMessage.addEventListener('click', () => {
//   document.cookie = 'shownBox=true;path=/;';
//   message.style.display = 'none';
// });

// const getCookie = cookie => {
//   const name = `${cookie}=`;
//   const ca = document.cookie.split(';');

//   for (let i = 0; i < ca.length; i++) {
//     let c = ca[i];

//     while (c.charAt(0) === ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) === 0) {
//       return c.substring(name.length, c.length);
//     }
//   }

//   return '';
// };

// if (!getCookie('shownBox')) {
//   message.classList.remove('hide');
// }

if (window.innerWidth < 768) {
  const countLines = () => {
    const divHeight = descText.offsetHeight;
    const lineHeight = parseInt(
      window.getComputedStyle(descText).lineHeight,
      0
    );

    return divHeight / lineHeight;
  };

  if (countLines() > 7) {
    readMore.addEventListener("click", () => {
      descText.classList.add("expanded");
      readMore.classList.add("expanded");
    });
  } else {
    descText.classList.add("expanded");
    readMore.classList.add("expanded");
  }
} else {
  descText.classList.add("expanded");
  readMore.classList.add("expanded");
}

for (const qqRootNode of quickQuoteNode) {
  ReactDOM.render(
    <QuickQuote
      schedulerModeIndex={4}
      hasCountries={false}
      hasResorts={false}
      brand="beaches"
      noLabels
      defaultResortCode={rstCode}
      quoteButtonText="Rates &amp; Availability"
      occupancyLabels={false}
      startDatePlaceholderText="Check In"
      endDatePlaceholderText="Check Out"
      adultsDropdownPlaceHolder="<span class='occupancy-placeholder'>Adults<span class='display-block'>(Age 16+)</span></span>"
      childrenDropdownPlaceHolder="<span class='occupancy-placeholder'>Kids<span class='display-block'>(Age 0-15)</span></span>"
    />,
    qqRootNode
  );
}

//Reviews
const urlReviews = {
  showReviews: beaches_app.page.queryParams.showReviews,
  resort: beaches_app.page.queryParams.resort,
};

const resorts = beaches_app.page.resortList;
const allSliders = beaches_app.page.allSliders;
const resortsList = resorts.map((resort) => {
  const slider = allSliders[resort.code.toLowerCase()];
  const slidesTotal = slider.count;
  const slidesPath = slider.path;
  let slidesCount = 0;

  const slides = Array(slidesTotal - slidesCount + 1)
    .fill()
    .map(() => {
      slidesCount++;

      return `${slidesPath}/thumb-${slidesCount}.jpg`;
    });

  return {
    code: resort.code,
    shortName: resort.shortName,
    countryName: resort.countryName,
    city: resort.city,
    url: resort.url,
    images: slides,
  };
});

const resortsListFilter = resortsList.filter((r) => r.code == rstCode);

ReactDOM.render(
  <ReviewPanel resorts={resortsListFilter} urlReviews={urlReviews} />,
  guestReviews
);
